import { numberFormat } from 'shared/util'
import { Chip, ChipProps } from '@mui/material'

type RankChipsProps = {
  rank?: number
} & ChipProps
export const RankChips = ({
  rank,
  ...others
}: RankChipsProps) => rank ? (
  <Chip label={`${numberFormat(rank)}位`} {...others}/>
) : (
  <></>
)